import create from 'zustand';
import {persist} from 'zustand/middleware';
import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '@/Utils/CommonUtils';

interface TimerStoreState {
  isTimerOn: boolean;
  isToggleEnabled: boolean;
  setIsTimerOn: (val: boolean) => void;
  setIsToggleEnabled: (val: boolean) => void;
}

const useTimerStore = create(
  persist<TimerStoreState>(
    set => ({
      isTimerOn: false,
      isToggleEnabled: false,

      setIsTimerOn: val => set({isTimerOn: val}),
      setIsToggleEnabled: val => set({isToggleEnabled: val}),
    }),
    {
      name: 'timer-store',
      getStorage: () => ({
        getItem: async (name: string) => {
          try {
            const result = await getLocalStorage(name);
            return result ? JSON.parse(result) : null;
          } catch (e) {
            console.error(`Failed to parse storage for ${name}`, e);
            await removeLocalStorage(name);
            return null;
          }
        },
        setItem: async (name: string, value: any) => {
          await setLocalStorage(name, JSON.stringify(value));
        },
        removeItem: async (name: string) => {
          await removeLocalStorage(name);
        },
      }),
    },
  ),
);

export default useTimerStore;
